module.exports = __webpack_public_path__ + "static/img/novalloy-plus-dedication-plaque02.6358e65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/novalloy-plus/novalloy-plus-dedication-plaque02.jpg
// module id = 830
// module chunks = 0